<template>
  <div>
    <div
      v-for="(debtor, index) in statement.subjects.debtors"
      :key="debtor + index + Math.random()"
    >
      <div class="form-base__title preview break">
        {{ `Должник №${index + 1}` }}
      </div>

      <div class="row-box mb-5">
        <Subject :statement="statement" :subject="debtor" />
      </div>
    </div>
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';

export default {
  name: 'Step1',
  components: {
    Subject,
  },
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
};
</script>
